

import React, { memo } from 'react';
import { Button, LabelWrapper, Text } from '../../../../../ui-kit';
import Caption from '../Caption';
import './_srt-captions.scss';









const PLACEHOLDER = 'SRT files contain caption information, they are a text based file delivered separately to your video and can be activated at will - Best for SEO/Multi-language videos.';

function onDeleteSrt({ onUpdate }) {
  return () => {onUpdate();};
}

function renderPlaceHolder() {
  return <Text noMargin caption>{PLACEHOLDER}</Text>;
}

function SrtCaptions({
  requestedAddons,
  appliedAddons,
  addSrt,
  updateSrt,
  disabled
}) {
  const { SRT_CAPTIONS } = requestedAddons;
  const { SRT_CAPTIONS: appliedSrtCaptions = [] } = appliedAddons;

  return (
    <LabelWrapper
      label="SRT Captions"
      divContainer
      extraLabelContent={!disabled &&
      <Button
        type="TERTIARY"
        prefix="addfat"
        onClick={addSrt}
        disabled={disabled} />}>



      <div className="srt-captions">
        {
        Array.isArray(SRT_CAPTIONS) && SRT_CAPTIONS.length > 0 ?
        SRT_CAPTIONS.map((language, index) => {
          const onUpdate = updateSrt(index);
          const selectedCaptions = SRT_CAPTIONS.
          filter(({ value }) => Boolean(value)).
          map(({ value }) => value);
          const appliedCaptions = Array.isArray(appliedSrtCaptions) ?
          appliedSrtCaptions.
          filter(({ value }) => Boolean(value)).
          map(({ value }) => value) :
          [];

          appliedCaptions.forEach((item) => {
            if (!selectedCaptions.includes(item)) {
              selectedCaptions.push(item);
            }
          });

          return (
            <Caption
              key={`${language.value}`}
              defaultLanguage={language}
              onChange={onUpdate}
              onDelete={onDeleteSrt({ onUpdate })}
              selectedCaptions={selectedCaptions}
              disabled={disabled}
              type="SRT_CAPTIONS" />);


        }) :
        renderPlaceHolder()}

      </div>
    </LabelWrapper>);


}

export default memo(SrtCaptions);